"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabsMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _TabList = require("../../components/TabList/TabList.styles");
var _TabPanel = require("../../components/TabPanel/TabPanel.styles");
var _constants = require("../../constants");
var fileTabCSS = function fileTabCSS(props) {
  var appearance = props.appearance,
    fluid = props.fluid;
  if (appearance !== _constants.TABS_APPEARANCES.file) {
    return '';
  }
  return (0, _styledToken.default)({
    borderColor: 'Button.tertiary.borderColor',
    borderRadius: 'Button.borderRadius',
    borderWidth: 'Button.borderWidth'
  }, function (_ref) {
    var borderColor = _ref.borderColor,
      borderRadius = _ref.borderRadius,
      borderWidth = _ref.borderWidth;
    return (0, _styledComponents.css)(["", "{border-bottom:0;}", "{border:", "px solid ", ";", "}"], _TabList.StyledTabList, _TabPanel.StyledTabPanel, borderWidth, borderColor, fluid ? '' : "border-top-right-radius: " + borderRadius + "px;");
  })(props);
};

/** @class TabsMixin */
/** @method */
var TabsMixin = function TabsMixin(props) {
  return (0, _styledComponents.css)(["", ""], fileTabCSS(props));
};
exports.TabsMixin = TabsMixin;